import { useState } from 'react'
import { FaPencilAlt, FaTrashAlt } from 'react-icons/fa'
import { FiMenu } from 'react-icons/fi'
import { DragDropContext, Droppable, Draggable } from '@hello-pangea/dnd'

import Modal from '../../../shared/modal/Modal'
import api from '../../../utils/api'
import ConfirmDeleteModal from '../../../shared/components/ConfirmDeleteModal/ConfirmDeleteModal'
import EditChecklistGroup from '../EditChecklistGroup'
import useFlashMessage from '../../../hooks/useFlashMessage'
import useMyPermission from '../../../hooks/useMyPermission'

function ListChecklistGroupRow({ dataArray, handleOnSuccess, myPermission, onReorder, dragEnabled }) {

    const [token] = useState(localStorage.getItem('token') || '')
    const { setFlashMessage } = useFlashMessage()

    const { checkPermission } = useMyPermission()
    const myPermissionEdit = checkPermission(myPermission, "checklistGroup_Edit")
    const myPermissionDelete = checkPermission(myPermission, "checklistGroup_Delete")

    const [modalEditChecklistGroup, setModalEditChecklistGroup] = useState(false)
    const [checklistGroupId, setChecklistGroupId] = useState("")
    const [modalDeleteItem, setModalDeleteItem] = useState(false)
    const [checklistGroupName, setChecklistGroupName] = useState("")

    const canDrag = dragEnabled && myPermissionEdit && !!onReorder

    async function deleteChecklistGroup(id) {
        let msgType = 'success'
        const data = await api.delete(`/checklistGroup/delete/${id}`, {
            headers: { Authorization: `Bearer ${JSON.parse(token)}` },
        }).then((response) => {
            handleOnSuccess()
            setModalDeleteItem(false)
            return response.data
        }).catch((err) => {
            msgType = 'error'
            return err.response.data
        })
        setFlashMessage(data.message, msgType)
    }

    function handleDragEnd(result) {
        if (!result.destination || result.destination.index === result.source.index) return
        const reordered = Array.from(dataArray)
        const [moved] = reordered.splice(result.source.index, 1)
        reordered.splice(result.destination.index, 0, moved)
        onReorder(reordered)
    }

    return (
        <div>
            <DragDropContext onDragEnd={handleDragEnd}>
                <Droppable droppableId="checklist-groups" isDropDisabled={!canDrag}>
                    {(provided) => (
                        <div ref={provided.innerRef} {...provided.droppableProps}>
                            {dataArray && dataArray.map((item, index) => (
                                <Draggable key={item._id} draggableId={item._id} index={index} isDragDisabled={!canDrag}>
                                    {(dragProvided, dragSnapshot) => (
                                        <div
                                            ref={dragProvided.innerRef}
                                            {...dragProvided.draggableProps}
                                            className={['pg-item', dragSnapshot.isDragging ? 'pg-item-dragging' : ''].join(' ')}
                                        >
                                            {canDrag && (
                                                <span className="pg-drag-handle" {...dragProvided.dragHandleProps} title="Arrastar para reordenar">
                                                    <FiMenu size={16} />
                                                </span>
                                            )}
                                            <div className="pg-item-main">
                                                <div className="pg-item-header">
                                                    <span className="pg-item-name">{item.name}</span>
                                                    {item.disabled && (
                                                        <span className="pg-item-status-disabled">Desabilitado</span>
                                                    )}
                                                </div>
                                                <span className="cg-item-order">Ordem: {item.order ?? 0}</span>
                                            </div>

                                            <div className='shd-row-box-item-action'>
                                                {myPermissionEdit &&
                                                    <FaPencilAlt
                                                        className='shd-icon-row-edit'
                                                        title='Editar'
                                                        onClick={() => { setChecklistGroupId(item._id); setModalEditChecklistGroup(true) }}
                                                    />
                                                }
                                                {myPermissionDelete &&
                                                    <FaTrashAlt
                                                        className='shd-icon-row-trash'
                                                        title='Apagar'
                                                        onClick={() => { setModalDeleteItem(true); setChecklistGroupId(item._id); setChecklistGroupName(item.name) }}
                                                    />
                                                }
                                            </div>
                                        </div>
                                    )}
                                </Draggable>
                            ))}
                            {provided.placeholder}
                        </div>
                    )}
                </Droppable>
            </DragDropContext>

            <Modal
                modalStatus={modalEditChecklistGroup}
                changeStatus={setModalEditChecklistGroup}
                w={60}
                content={
                    <EditChecklistGroup
                        id={checklistGroupId}
                        handleOnSuccess={() => { setModalEditChecklistGroup(false); handleOnSuccess() }}
                        btCancelAction={() => setModalEditChecklistGroup(false)}
                    />
                }
            />

            <ConfirmDeleteModal
                modalStatus={modalDeleteItem}
                changeStatus={setModalDeleteItem}
                onConfirm={() => deleteChecklistGroup(checklistGroupId)}
                message="Deseja realmente excluir esse grupo?"
                itemName={checklistGroupName}
            />
        </div>
    )
}

export default ListChecklistGroupRow
